var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.667 0H277.334C300.897 0 320 19.103 320 42.667V192C320 215.564 300.897 234.667 277.333 234.667H42.667C19.103 234.667 0 215.564 0 192V42.667C0 19.103 19.103 0 42.667 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.333 0H469.333C492.898 0 512 19.103 512 42.667V192C512 215.564 492.898 234.667 469.333 234.667H405.333C381.769 234.667 362.666 215.564 362.666 192V42.667C362.667 19.103 381.769 0 405.333 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.667 277.333H106.667C130.231 277.333 149.334 296.436 149.334 320V469.333C149.334 492.897 130.231 512 106.667 512H42.667C19.103 512 0 492.898 0 469.333V320C0 296.436 19.103 277.333 42.667 277.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.667 277.333H469.334C492.898 277.333 512 296.436 512 320V469.333C512 492.898 492.898 512 469.333 512H234.667C211.103 512 192 492.898 192 469.333V320C192 296.436 211.103 277.333 234.667 277.333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.f3e2d59a225e4d17eb418203f6dd62da.svg";
export { ForwardRef as ReactComponent };